import { render, staticRenderFns } from "./SortSelection.vue?vue&type=template&id=cbcbb6f8&"
import script from "./SortSelection.vue?vue&type=script&lang=ts&"
export * from "./SortSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports